import {FieldFilterDynamicListType} from "fello-model";
import {BaseDynamicList} from "./fql-base-dynamic-list-factory.service";

export abstract class AbstractFqlDynamicListFactoryService {
  abstract getDynamicList(dynamicListType: string): BaseDynamicList;
}
